import React from "react";
import { Col, Container, Row } from "reactstrap";
import styles from "./ExtendRow.module.scss";

const ExtendOpningRow = (props) => {
  return (
    <Container className={styles.ExtendPage}>
      <Row className={styles.ExtendRow}>
        <Col md={2} className={styles.ExtendCol}>
          <span className={styles.ExtendCardText}>No. of Openings</span>
          <span className={styles.ExtendCardTitle}>
            {props?.data?.noOfProfiles}
          </span>
        </Col>
        <Col md={2} className={styles.ExtendCol}>
          <span className={styles.ExtendCardText}>Experience</span>
          <span className={styles.ExtendCardTitle}>
            {" "}
            {props?.data?.experienceYear +
              " Y " +
              props?.data?.experienceMonth +
              " M"}
          </span>
        </Col>
        {/* <Col md={2} className={styles.ExtendCol}>
          <span className={styles.ExtendCardText}>Status</span>
          <span className={styles.ExtendCardTitle}>
            {props?.data?.jobStatus}
          </span>
        </Col> */}
        {props?.data?.positionType ? (
          <Col md={2} className={styles.ExtendCol}>
            <span className={styles.ExtendCardText}>Position Type</span>
            <span className={styles.ExtendCardTitle}>
              {props?.data?.positionType}
            </span>
          </Col>
        ) : (
          ""
        )}
        {props?.data?.jobType ? (
          <Col md={2} className={styles.ExtendCol}>
            <span className={styles.ExtendCardText}>Job Type</span>
            <span className={styles.ExtendCardTitle}>
              {props?.data?.jobType}
            </span>
          </Col>
        ) : (
          ""
        )}
        {props?.data?.location ? (
          <Col md={2} className={styles.ExtendCol}>
            <span className={styles.ExtendCardText}>Location</span>
            <span className={styles.ExtendCardTitle}>
              {props?.data?.location}
            </span>
          </Col>
        ) : (
          ""
        )}
        {props?.data?.user_data ? (
          <Col md={2} className={styles.ExtendCol}>
            <span className={styles.ExtendCardText}>Created By</span>
            <span className={styles.ExtendCardTitle}> 
              {props?.data?.user_data?.name   } { props?.data?.user_data?.lastName ? props?.data?.user_data?.lastName  : ""}
            </span>
          </Col>
        ) : (
          ""
        )}
      </Row>
    </Container>
  );
};

export default ExtendOpningRow;
